import {colorGenerator} from "../utils/calculate"

export const lineOptions = {
    plugins: {
        legend: {
            display: true,
            position: "right",
            maxWidth: 120,
            maxHeight: 2,
            rtl: false,
            labels: {
                boxHeight: 15,
                boxWidth: 60
            }
        }
    },
    maintainAspectRatio: false
}
export const barOptions = (defaultValue: number) => {
    return {
        plugins: {
            legend: {
                display: false
            }
        },
        scales: {
            y: {
                max: defaultValue
            }
        }
    }
}
export const doughnutOptions = {
    cutout: 65 + "%",
    rotation: 270,
    radius: 100 + "%",
    circumference: 180,
    animation: {
        animateRotate: true,
        animateScale: false
    },
    events: [],
    plugins: {
        tooltip: {
            enabled: false
        }
    }
}

export const doughnutDatas = (value: number, default_value: number, default_color: string) => {
    return {
        datasets: [
            {
                data: [value, default_value],
                backgroundColor: [default_color, "rgba(195, 191, 191, 0.96)"],
                borderColor: [default_color, "rgba(195, 191, 191, 0.96)"],
                borderWidth: 1,
                hoverOffset: 0,
                hoverBorderWidth: 0,
                hoverBorderJoinStyle: "miter"
            }
        ]
    }
}

export const pieDatas = (labels: string[], data: number[], backgrounds: any[]) => {
    return {
        labels: labels,
        datasets: [
            {
                label: "",
                data: data.some(v => v <= 0) ? [1] : data,
                backgroundColor: colorGenerator(backgrounds.length),
                borderColor: ["#6a6a6a"],
                color: ["#fff"],
                borderWidth: 1,
                maxBarThickness: 18,
                barPercentage: 0.5,
                base: 0
            }
        ]
    }
}

export const barDatas = (labels: string[], data: number[], colors: string[]) => {
    return {
        labels: labels,
        datasets: [
            {
                label: "",
                data: [...data],
                backgroundColor: colors,
                borderColor: colors,
                color: ["#fff"],
                borderWidth: 1,
                maxBarThickness: 18,
                barPercentage: 0.5,
                base: 0
            }
        ]
    }
}
